import i18n from 'i18next';
import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({}) => {
  return {
    config_jurisdictionLocation: {
      [SERVICE_PROVIDERS.TP]: () => i18n.t('fuelConsumption.JurisdictionLocation'),
      default: () => i18n.t('fuelConsumption.Jurisdiction'),
    },
    generateRows_jurisdictionLocation: {
      [SERVICE_PROVIDERS.TP]: () => true,
      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
